module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tw-relative",
    class: {
      'tw-h-full': _vm.maxheight === 0
    },
    style: ({
      'max-height': _vm.maxheight === 0 ? 'none' : _vm.maxheight + 'px'
    })
  }, [_c('div', {
    ref: "viewHeight",
    staticClass: "tw-overflow-hidden",
    class: [{
        'tw-pr-5': _vm.displayScrollbar && _vm.padding
      },
      {
        'tw-pr-2': _vm.displayScrollbar && !_vm.padding
      },
      {
        'tw-h-full': _vm.maxheight === 0
      }
    ],
    style: ({
      'max-height': _vm.maxheight === 0 ? 'none' : _vm.maxheight + 'px'
    })
  }, [_c('div', {
    ref: "fullHeight"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    ref: "track",
    staticClass: "tw-bg-gray-200 tw-w-2 tw-h-full tw-absolute tw-right-0 tw-top-0 tw-overflow-hidden tw-z-10",
    class: {
      'tw-hidden': !_vm.displayScrollbar,
      'tw-rounded': _vm.rounded
    }
  }, [_c('div', {
    ref: "thumb",
    staticClass: "tw-bg-gray-400 tw-w-2 tw-relative tw-transition-all tw-duration-200"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b22edf2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/shared/components/VerticalScroll/vertical-scroll.vue.html
// module id = x6zU
// module chunks = 2